import { getThingModelPropertyDevice, getAllProducts, getAllDevices, getProductDetail, getThingModelExportData } from '@/api/data/history';
import CommonLayout, { CommonLayoutInstance } from '@/components/CommonLayout';
import { downloadXlsx } from '@/utils/download';
import { Button, DatePicker, Flex, Form, FormListFieldData, Select, Space, Spin } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import React, { useEffect, useRef, useState } from 'react';
import Line, { EChartsOption } from './components/Line';
import HistoryWorker from './components/history.worker';

const QueryItem = ({ name, productList }: FormListFieldData & { productList: { name: string; id: string }[] }) => {
  const form = Form.useFormInstance();

  const [deviceList, setDeviceList] = useState<{ id: string; name: string }[]>([]);
  const getDeviceList = async (product_id: string) => {
    if (!product_id) {
      setDeviceList([]);
      return;
    }
    try {
      const res = await getAllDevices({ product_id, isAll: true });
      const list = res?.result?.list || [];
      setDeviceList(list);
    } catch {
      setDeviceList([]);
    }
    // if (isInitial) CommonLayoutRef.current?.formRef?.setFieldValue('device_ids', list[0]?.id);
  };

  const [codeList, setCodeList] = useState<{ code: string; name: string }[]>([]);

  const getCodeList = async (id: string) => {
    if (!id) {
      setCodeList([]);
      return;
    }
    try {
      const res = await getProductDetail({ id });
      const list = res?.result?.properties?.filter((item: { type_spec: { type: string } }) => ['int', 'float'].includes(item?.type_spec?.type)) || [];
      setCodeList(list);
    } catch {
      setCodeList([]);
    }
  };

  const product_id = Form.useWatch(['query', name, 'product_id'], form);
  // const device_id = Form.useWatch(['query', name, 'device_id'], form);

  useEffect(() => {
    getDeviceList(product_id);
    getCodeList(product_id);
  }, [product_id]);

  // useEffect(() => {
  //   getCodeList(device_id);
  // }, [device_id]);

  return (
    <>
      <Form.Item name={[name, 'product_id']}>
        <Select
          options={productList}
          placeholder="产品"
          style={{ minWidth: '120px' }}
          fieldNames={{ value: 'id', label: 'name' }}
          optionFilterProp="name"
          onChange={(value) => {
            form.setFieldValue(['query', name], { product_id: value });
          }}
          showSearch
        ></Select>
      </Form.Item>
      <Form.Item name={[name, 'device_id']}>
        <Select
          options={deviceList}
          key="more_deviceList"
          showSearch
          fieldNames={{ label: 'name', value: 'id' }}
          optionFilterProp="name"
          placeholder="设备"
          style={{ minWidth: '120px' }}
          allowClear
        ></Select>
      </Form.Item>
      <Form.Item name={[name, 'code']}>
        <Select options={codeList} key="more_codeList" fieldNames={{ label: 'name', value: 'code' }} placeholder="参数" style={{ minWidth: '120px' }} allowClear></Select>
      </Form.Item>
    </>
  );
};

const DataHistory = () => {
  const worker = useRef<Worker>();
  useEffect(() => {
    worker.current = new HistoryWorker();
    return () => {
      worker.current?.terminate?.();
    };
  }, []);
  const CommonLayoutRef = useRef<CommonLayoutInstance<{ params: {}; model: {}; drawerParams: {}; drawerModel: {} }>>(null);
  const [productList, setProductList] = useState<{ name: string; id: string }[]>([]);
  const getProductList = async () => {
    try {
      const res = await getAllProducts({ isAll: true });
      const list = res?.result?.list || [];
      setProductList(list);
      // const product_id = list[0]?.id;
      // getDataByProductId(product_id);
      // CommonLayoutRef.current?.formRef?.setFieldValue('product_id', product_id);
    } catch {}
  };

  useEffect(() => {
    getProductList();
  }, []);

  // const [codeList, setCodeList] = useState<{ code: string; name: string }[]>([]);

  // const getCodeList = async (id: string) => {
  //   const res = await getProductDetail({ id });
  //   const list = res?.result?.properties?.filter((item: { type_spec: { type: string } }) => ['int', 'float'].includes(item?.type_spec?.type)) || [];
  //   setCodeList(list);
  //   // if (isInitial) CommonLayoutRef.current?.formRef?.setFieldValue('codes', [list[0]?.code]);
  // };

  // const [deviceList, setDeviceList] = useState<{ id: string; name: string }[]>([]);
  // const getDeviceList = async (product_id: string) => {
  //   const res = await getAllDevices({ product_id, isAll: true });
  //   const list = res?.result?.list || [];
  //   setDeviceList(list);
  //   // if (isInitial) CommonLayoutRef.current?.formRef?.setFieldValue('device_ids', list[0]?.id);
  // };

  // const getDataByProductId = async (product_id: string) => {
  //   if (!product_id) return;
  //   try {
  //     await Promise.all([getDeviceList(product_id), getCodeList(product_id)]);

  //     // if (isInitial) CommonLayoutRef.current?.reload({ ...CommonLayoutRef.current?.formRef.getFieldsValue(), searchFromType: 'searchForm' });
  //   } catch {}
  // };

  // const search_type = Form.useWatch('search_type', CommonLayoutRef.current?.formRef);

  const [exportLoading, setExportLoading] = useState<boolean>(false);
  const [chartLoading, setChartLoading] = useState<boolean>(false);

  const [allData, setAllData] = useState<{ time: number; value: number; device_name: string; name: string }[]>([]);

  const [chartOptions, setChartOptions] = useState<EChartsOption>({});
  const transForm = (values: { device_name: string; name: string; report_data: { time: number; value: number }[] }[]) => {
    worker.current?.postMessage(values);

    if (worker.current) {
      // @ts-ignore
      worker.current.onmessage = ({ data }: { data: { options: EChartsOption; allData: { time: number; value: number; device_name: string; name: string }[] } }) => {
        setChartOptions(data.options);
        setAllData(data.allData);
        // setChartLoading(false);
        setTimeout(() => {
          setChartLoading(false);
        }, 0);
      };
    }
  };
  return (
    <CommonLayout
      ref={CommonLayoutRef}
      searchFormProps={{
        // onValuesChange: (changedValues, { product_id, search_type, range }) => {
        //   const [key, value] = Object.entries(changedValues)[0];
        //   if (['product_id', 'search_type'].includes(key)) {
        //     CommonLayoutRef.current?.formRef?.setFieldsValue({ product_id, search_type, range, device_ids: undefined, codes: undefined });
        //   }
        //   if (key === 'product_id') {
        //     getDataByProductId(value as string);
        //   }
        // },
        initialValues: {
          query: [{}],
          range: [dayjs().subtract(3, 'hour').valueOf(), dayjs().valueOf()],
        },
      }}
      breadcrumb={{ title: '历史查询', describe: '历史查询功能支持单个设备属性查询，同时也支持多设备不同属性查询用作对比，结果以折线图和表格的形式展示，并且支持导出' }}
      ajaxJson={{
        get: {
          ajax: getThingModelPropertyDevice,
          convertValue: (p) => ({ ...CommonLayoutRef.current?.formRef?.getFieldsValue(), ...p, isAll: true }),
          transform: (values) => {
            transForm(values || []);
            return {};
          },
          beforeFun: () => {
            setChartLoading(true);
          },
          finallyFun: () => {
            setChartLoading(false);
          },
        },
        export: {
          ajax: getThingModelExportData,
          convertValue: () => ({ ...CommonLayoutRef.current?.formRef?.getFieldsValue(), isAll: true }),
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          transform: (_result, rest) => {
            const { res } = rest || {};
            const fileName = window.decodeURI(res.headers['content-disposition']?.split('=')[1] || '');
            downloadXlsx(res.data, fileName);
            return {};
          },
          operateName: '导出',
          beforeFun: () => {
            setExportLoading(true);
          },
          finallyFun: () => {
            setExportLoading(false);
          },
        },
      }}
      isNotToInitial={true}
      isHideDrawer
      // @ts-ignore
      tableProps={{ rowKey: (record) => JSON.stringify(record), pagination: chartLoading ? undefined : {}, dataSource: allData, loading: chartLoading }}
      searchFormChildren={
        <Space wrap>
          <Flex vertical gap={8}>
            <Form.List name="query">
              {(fields, { add, remove }) => {
                return (
                  <>
                    {fields.map((item) => (
                      <Flex key={item.name} gap={8}>
                        <QueryItem key={item.key} name={item.name} productList={productList}></QueryItem>
                        <Space>
                          <Button
                            onClick={() => {
                              add({});
                            }}
                          >
                            添加
                          </Button>
                          <Button
                            onClick={() => {
                              remove(item.name);
                            }}
                            disabled={fields.length === 1}
                          >
                            删除
                          </Button>
                        </Space>
                      </Flex>
                    ))}
                  </>
                );
              }}
            </Form.List>
          </Flex>
          {/* <Form.Item name="product_id">
            <Select options={productList} placeholder="产品" style={{ minWidth: '120px' }} fieldNames={{ value: 'id', label: 'name' }} optionFilterProp="name"></Select>
          </Form.Item>
          <Form.Item name="search_type">
            <Select
              options={[
                { label: '一个设备多个参数', value: 'one' },
                { label: '多个设备单个参数', value: 'more' },
              ]}
              style={{ minWidth: '200px' }}
              placeholder="请选择"
            ></Select>
          </Form.Item>
          <Form.Item name="device_ids" key="more_device_ids">
            <Select
              options={deviceList}
              key="more_deviceList"
              mode={search_type === 'one' ? undefined : 'multiple'}
              fieldNames={{ label: 'name', value: 'id' }}
              optionFilterProp="name"
              placeholder="设备"
              style={{ minWidth: '120px' }}
              allowClear
            ></Select>
          </Form.Item>
          <Form.Item name="codes" key="more_code">
            <Select
              options={codeList}
              mode={search_type !== 'one' ? undefined : 'multiple'}
              key="more_codeList"
              fieldNames={{ label: 'name', value: 'code' }}
              placeholder="参数"
              style={{ minWidth: '120px' }}
              allowClear
            ></Select>
          </Form.Item> */}
          <Form.Item name="range" getValueFromEvent={(e: Dayjs[]) => e.map((item) => item.valueOf())} getValueProps={(e: number[]) => ({ value: e.map((item) => dayjs(item)) })}>
            <DatePicker.RangePicker format="YYYY-MM-DD HH:mm:ss" showTime></DatePicker.RangePicker>
          </Form.Item>
        </Space>
      }
      columns={[
        { title: '设备名称', dataIndex: 'device_name' },
        { title: '属性名称', dataIndex: 'name' },
        { title: '属性值', dataIndex: 'value' },
        { title: '时间', dataIndex: 'time', render: (v: number) => dayjs(v).format('YYYY-MM-DD HH:mm:ss') },
        // { title: '属性名称', dataIndex: 'device_name' },
      ]}
      rightOperateButtonList={[
        {
          name: '导出',
          ajaxKey: 'export',
          props: { type: 'primary', loading: exportLoading },
          isToAjax: true,
        },
      ]}
      mainBeforeContent={
        <Spin spinning={chartLoading}>
          <div style={{ width: '100%', height: '500px' }}>
            <Line options={chartOptions}></Line>
          </div>
        </Spin>
      }
      // mainType={undefined}
    ></CommonLayout>
  );
};
export default DataHistory;
